var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSaoTomeAndPrince(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73884 10.4456H31.0045C28.7438 4.35274 22.8791 0.0107422 15.9997 0.0107422C11.5813 0.0107422 7.58177 1.80193 4.68652 4.69755L9.73884 10.4456Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73884 21.5759H31.0045C28.7438 27.6687 22.8791 32.0107 15.9997 32.0107C11.5813 32.0107 7.58177 30.2196 4.68652 27.3239L9.73884 21.5759Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68625 4.69702C-1.56212 10.9454 -1.56212 21.0761 4.68625 27.3245C7.26831 24.7425 9.75163 22.2591 16 16.0108L4.68625 4.69702Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3174 13.228L21.0081 15.3538H23.2432L21.435 16.6675L22.1257 18.7933L20.3174 17.4795L18.5092 18.7933L19.1998 16.6675L17.3916 15.3538H19.6267L20.3174 13.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2737 13.228L27.9643 15.3538H30.1994L28.3912 16.6675L29.0819 18.7933L27.2737 17.4795L25.4654 18.7933L26.1561 16.6675L24.3478 15.3538H26.5829L27.2737 13.228Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSaoTomeAndPrince);
export default __webpack_public_path__ + "static/media/flag_sao_tome_and_prince.bbdff47060b28e8ddcef24c5d72cbe2f.svg";
export { ForwardRef as ReactComponent };